import React from "react";
import banner from "../../images/l-banner.jpg";
import arrow from "../../images/l-arrow-down.svg";
import { Link } from "react-router-dom";

const Banner = ({ setuserContextState }) => {
  return (
    <section className="banner" id="about">
      <div className="container">
        <div className="banner-left col-50">
          <h1>The future of council management</h1>
          <p>
            Engage your local communities effectively through events, attraction
            info and deals.
          </p>
          <div className="getstarted-row">
            <Link
              to="/splash"
              className="getstarted-btn"
              onClick={() => {
                setuserContextState((prevValue) => ({
                  ...prevValue,
                  route: "/onboarding",
                }));
              }}
            >
              get started
            </Link>
            <div className="icon">
              <a href="#banner_full_view">
                <img src={arrow} alt="down arrow" />
              </a>
            </div>
          </div>
        </div>
        <div className="banner-right col-50">
          <img src={banner} alt="banner" />
        </div>
      </div>
    </section>
  );
};

export default Banner;
